import { useNavigate } from "react-router-dom";
import { useSearchParams, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import EmailValidator from "email-validator";
import {Button} from "@mui/material";
import googleImg from "../../assets/images/google.png";

  
import '../style.css';
const SignupPage: React.FC = () => {
	 const [email, setEmail] = useState("");
	 const [error, setError] = useState<boolean>(false);
	const navigate =  useNavigate();
	const location = useLocation(); 
	const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
	const conTinue = () =>{
		const isvalidEmail = EmailValidator.validate(email.trim());
		setError(isvalidEmail ? false : true);
		if(email.trim() !== "" && isvalidEmail){
		if(type === "login"){
			navigate("/login/password", { state: { email } })
		}else{
		navigate("/signup/password", { state: { email } });
		}
	}
	// else{
	// 	alert("Add email first")
	// }
	}
	const handleGoogleLogin = () => {
		window.location.href = "https://scsbcback.makemagento.com/auth/login";
	  };

	  useEffect(()=>{
		if(location.state?.email){
			setEmail(location.state?.email);
		}
	  }, [location.state?.email])
	return (<>
	  <div className="main-singup sign-inner-page" >
		<div className="signup-inner" >
		  <h2>
		  {type === "login" ? " Welcome back" :" Create an account"}
		  </h2>
		  
		  <div className="email-inner" >
			{/* <input
			  type="email"
			  onChange={(e)=>{setEmail(e.target.value)}}
			  placeholder="Enter your email"
			/>
			<label>Email address*</label> */}
			<div className="input-container">
        <input type="email"
		value={email}
			  onChange={(e)=>{setEmail(e.target.value)}}
			  placeholder=" "
			/>
        <label >Email address*</label>
		
    </div>
	<p style={{color: "red"}}>{error ? "Email is not valid.": ""}</p>
	<Button onClick={conTinue} variant="contained" sx={{ textTransform: "none" }}>
		Continue
	</Button>
  </div>
		  
		  <p className="login-account" >
		  {type === "login" ?  "Don't have an account?" : "Already have an account?"}
		  {type === "login" ? 
		   <a href="/authorize?type=signup" style={{ color: '#10b981' }}>
		 Sign Up</a>:
		  <a href="/authorize?type=login" style={{ color: '#10b981' }}>
		  Login
			</a>
}
		  </p>
		  
		  <div className="or-inner" >
			<hr  />
			<span >OR</span>
			<hr />
		  </div>
		  
		  <div className="continue-inner-page">
			
			<button onClick={handleGoogleLogin}>
			  <img 
			  			//   src="/google.png"
						  			   src={googleImg}
						  

			  alt="Google" />
			  Continue with Google
			</button>


			
		  </div>
		</div>
	  </div>

<div className="footer-innner">

<p className="term-part" >
	  <a href="#" >Terms of Use</a>  |  <a href="#" >Privacy Policy</a>
	</p>
</div>

</>	);
  }
  export default SignupPage;